var React = require('react');

function ProcessArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"V4","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"TB_Website_Desktop_Work_TheBeerStore","transform":"translate(-173.000000, -1808.000000)","fill":"#222A35","fillRule":"nonzero"},React.createElement("g",{"id":"Process","transform":"translate(130.000000, 1698.000000)"},React.createElement("path",{"id":"Line-2-Copy-2","d":"M388.689741,110.750909 L403.102227,118.87794 L388.672643,126.974574 L387.693958,125.23039 L397.244,119.871 L43.4989466,119.498946 L43.5010545,117.498947 L397.246,117.872 L387.707382,112.493026 L388.689741,110.750909 Z"})))));
}

ProcessArrow.defaultProps = {"width":"361px","height":"17px","viewBox":"0 0 361 17","version":"1.1"};

module.exports = ProcessArrow;

ProcessArrow.default = ProcessArrow;
